import React, { useEffect, useState } from 'react'
import { pageTitles } from './constants';
import { AuthService } from '../../services/AuthService';

interface Props {
    count: number;
}

const BadgeNotif = (props: Props) => {
    const [count, setCount] = useState(0);
    const [prevCount, setPrevCount] = useState(null);
    const [animateNotif, setAnimateNotif] = useState<boolean>(false)
    const [showNotifBellIcon, setShowNotifBellIcon] = useState(false);

    useEffect(() => {
        setPrevCount(count);
        setCount(props.count)
    }, [props.count]);

    useEffect(() => {
        if (count > prevCount) {
            setAnimateNotif(true)
        }
    }, [count])

    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (animateNotif) {
            timer = setTimeout(() => {
                setAnimateNotif(false);
            }, 10000);
        }

        return () => clearTimeout(timer);

    }, [animateNotif])

    useEffect(() => {
        let intervalId: NodeJS.Timeout;

        if (count) {
            intervalId = setInterval(() => {
                setShowNotifBellIcon(prev => !prev);
            }, 500);
        }

        return () => clearInterval(intervalId);
    }, [count]);

    useEffect(() => {
        if (animateNotif) {
            document.title = showNotifBellIcon ? "🔔 New Message!" : "💬 Check your inbox!";
        }
        else {
            if (document && AuthService.loggedIn() && AuthService.is2FACompleted()) {
                document.title = `${pageTitles.DOCUMENT_TITLE} ${!!count ? `(${count})` : ''}`
            }
        }
    }, [animateNotif, showNotifBellIcon]);

    return (
        <span className="d-flex justify-center align-center ml-auto mr-1 min-w-3 min-h-3 alert-bubble">
            <span className={`side-bar-highlight-badge d-flex b-none r-1 w-p-100 h-p-100 ${count > 999 ? "br-1" : "br-p-50"} ${animateNotif && 'bubble'}`}>
                <span className="m-auto" style={{ paddingTop: "2px" }}>
                    {count}
                </span>
            </span>
        </span>
    )
}

export default BadgeNotif